import React from 'react';

import { AuthContext } from 'components/contexts/AuthCtx';

export const useAuth = () => {
  const { authController } = React.useContext(AuthContext);

  if (!authController) {
    // console.warn()
    throw new Error(
      'useAuth should only be used within the AuthContext. Alternatively, use useAuthController directly',
    );
  }

  return authController;
};

export default useAuth;
